import Vue from 'vue';

export default Vue.component('shimmer-bar', {
  template: require('./template.html'),
  name: 'shimmer-bar',
  props: {
    styles: {
      type: Object,
      require: false,
      default: () => ({}),
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/components/shimmers/bar/index.js